export interface DraftFullId {
    ns: string;
    draftId: string;
}
